import React, { Fragment, useContext } from "react";
import { Link } from "react-router-dom";
import { AppHelper } from "../../App";
import ScrollTop from "../UI/ScrollTop";
import PostyJSON from "../../localization/posty.json";
import { LanguageContext } from "../../App";
import classes from "./MainGrid.module.css";

function MainGrid(props) {
  const postyJSON = PostyJSON;
  let langcontext = useContext(LanguageContext);

  function ReturnPanel(postyJSON) {
    const arr = postyJSON
      .sort((a, b) => Date.parse(b.date) - Date.parse(a.date))
      .map((post) => {
        let id = post.id;
        let imgsrcurl = `${AppHelper.storageUrl}media/posty/${id}_main.png`;

        return (
          <Link to={`${id}`} key={post.id}>
            <div className={classes.itemcontainer}>
              <img
                className={classes.mainimage}
                src={imgsrcurl}
                alt={post.title.pl}
              ></img>
              <div className={classes.titleslide}>
                {AppHelper.ReturnLanguageContent(post.title, langcontext)}
              </div>
              <div className={classes.blueoverlay}></div>

              <div className={classes.textbox}>
                <div className={classes.date}>
                  {new Date(Date.parse(post.date))
                    .toISOString()
                    .substring(0, 7)}
                </div>
              </div>
            </div>
          </Link>
        );
      });
    return arr;
  }

  return (
    <Fragment>
      <div className={classes.main}>
        <div className={classes.grid}>{ReturnPanel(postyJSON)}</div>
      </div>
      <div className={classes.bottombox}></div>
      <ScrollTop />
    </Fragment>
  );
}

export default MainGrid;
